var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSiteminder(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 16,
    viewBox: "0 0 12 16",
    width: 12,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#006dff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m7.9928 10.6263v1.988l-7.99231172 1.3997v1.986l9.98848172-1.7515c.54843-.109 1.04383-.3988 1.40603-.8223.3623-.4236.5702-.9562.5901-1.5118v-7.94419l-3.99611.69985z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m2.00058 1.74962c-.54733.11062-1.04121.40127-1.401987.82507-.360777.42381-.5674128.95606-.5865767 1.5109v7.94421l3.9961537-.6999v-7.94416l7.99233-1.40158v-1.98416z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiteminder);
export default __webpack_public_path__ + "static/media/siteminder.0e931855e4c068d75674fa0c6f19a3cd.svg";
export { ForwardRef as ReactComponent };